import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckboxSVG from "../checkbox-icon";
import { StyledProductCardFeatures } from "./product-card-features.scss";
const ProductCardFeatures = ({ features })=>/*#__PURE__*/ _jsxs(StyledProductCardFeatures, {
        className: "product-card-features",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "divider"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "features",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: "Popular features:"
                    }),
                    features === null || features === void 0 ? void 0 : features.map(({ feature })=>/*#__PURE__*/ _jsxs("div", {
                            className: "feature",
                            children: [
                                /*#__PURE__*/ _jsx(CheckboxSVG, {}),
                                feature
                            ]
                        }))
                ]
            })
        ]
    });
export default ProductCardFeatures;
